import { connect } from 'react-redux';
import { voidInvoiceBegin } from 'src/store/actions/accounting.actions';
import { downloadInvoicesBegin, getJournalEntriesBegin } from '../../store/actions/accounting.actions';
import { getJournalEntries, getJournalEntriesLoading } from '../../store/selectors/accounting.selectors';
import InvoicesDialog from './InvoicesDialog';
import { getMergeTemplatesList } from 'src/store/selectors/license.selectors';
import { getMergeTemplatesBegin, mergeDocumentsBegin } from 'src/store/actions/license.actions';

const mapStateToProps = (state: any) => ({
    journalEntries: getJournalEntries(state),
    journalEntriesLoading: getJournalEntriesLoading(state),
    mergeTemplatesList: getMergeTemplatesList(state),
});

const mapDispatchToProps = {
    getJournalEntries: getJournalEntriesBegin,
    downloadInvoices: downloadInvoicesBegin,
    voidInvoice: voidInvoiceBegin,
    getMergeTemplatesBegin,
    mergeDocuments: mergeDocumentsBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesDialog);
